/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./logoNiotix.vue?vue&type=template&id=55169c76&"
import script from "./logoNiotix.vue?vue&type=script&lang=js&"
export * from "./logoNiotix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports